var _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRibbonArrowRight = function SvgRibbonArrowRight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "18px",
    viewBox: "0 0 10 18",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Arrow &gt;")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.699999988
  }, /*#__PURE__*/React.createElement("g", {
    id: "1340-UI",
    transform: "translate(-80.000000, -730.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(40.000000, 116.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 604.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.2218542,19.0185057 L49.4133773,26.3147326 C49.7204539,26.62628 49.7204681,27.1266689 49.4134092,27.4382337 C49.1120379,27.7440275 48.6198333,27.7476127 48.3140395,27.4462413 C48.3113665,27.443607 48.3087126,27.4409533 48.306078,27.4382805 L41.1142984,20.1421989 L41.1112775,20.1452638 L40,19.0182343 L40.0032007,19.014987 L40,19.0117399 L41.1072837,17.8877078 L41.1107873,17.8912624 L48.3331936,10.5636231 C48.6356566,10.2567531 49.1296185,10.2531806 49.4364885,10.5556435 C49.4391314,10.5582485 49.4417557,10.5608723 49.4443612,10.5635148 C49.7525063,10.8760276 49.7525552,11.3780796 49.4444711,11.6906526 L42.2218542,19.0185057 Z",
    id: "Arrow->",
    transform: "translate(45.000000, 18.834973) scale(-1, 1) translate(-45.000000, -18.834973) "
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRibbonArrowRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ribbonArrowRight.d48dcc76.svg";
export { ForwardRef as ReactComponent };